import { combineEpics } from 'redux-observable';
import { createTracLinkEpic } from './create-traclink';
import { getTracPageEpic } from './get-tracpage';
import { getTracPageForArtistEpic } from './get-tracpage-for-artist';
import { getArtistTracLinksEpic } from './get-artist-traclinks';
import { listTracLinksEpic } from './list-traclinks';
import { updateTracLinkEpic } from './update-traclink';
import { updateTracPageEpic } from './update-tracpage';
import { deleteTracLinkEpic } from './delete-traclink';
import { autosaveEpic } from './autosave';
import { updateTracPageSuccessEpic } from './update-tracpage-success';

const tracPageEpic = combineEpics(
  getTracPageEpic,
  getTracPageForArtistEpic,
  updateTracPageEpic,
  updateTracLinkEpic,
  getArtistTracLinksEpic,
  listTracLinksEpic,
  createTracLinkEpic,
  deleteTracLinkEpic,
  autosaveEpic,
  updateTracPageSuccessEpic
);

export default tracPageEpic;
